import React from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const CancelPage = () => {
  const { language } = useLanguage();
  const text = dashboardContent[language].cancelPage;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-red-100">
      <h1 className="text-3xl font-bold text-red-600 mb-4">{text.title}</h1>
      <p className="text-gray-700 mb-8">{text.message}</p>
      <a
        href="/dashboard/abo"
        className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded mt-8"
      >
        {text.buttonText}
      </a>
    </div>
  );
};

export default CancelPage;
